// First check if window.ENV exists (for runtime Docker injection)
const getRuntimeEnv = (key, defaultValue) => {
    if (window.ENV && window.ENV[key]) {
        return window.ENV[key];
    }
    return process.env[key] || defaultValue;
};

const ENV = getRuntimeEnv('REACT_APP_BUILD_ENV', 'development');

// Define URLs with preference for runtime values
const url = {
    //production: 'https://api-afc.agction.id/api/v1',
    production: 'https://afction.astra.co.id/afcapi/api/v1',
    staging: 'https://api-afc.ujiaplikasi.com/api/v1',
    development: 'http://localhost:5000/api/v1'
};

const url_public = {
    //production: 'https://api-afc.agction.id/',
    production: 'https://afction.astra.co.id/afcapi',
    staging: 'https://api-afc.ujiaplikasi.com',
    development: 'http://localhost:5000'
};

export const BASE_API = url[ENV];
export const BASE_URL = url_public[ENV];

export const COLOR = {
    primary: '#006aaf',
    secondary: '#f39c12',
    emas: '#fec107',
    hijau: '#00af00',
    biru: '#03a9f3',
    merah: '#fe1313',
    hitam: '#454545',
    abu: '#A2A2A2',
    ungu: '#ab8ce4'
};

export const ROLE = {
    ADMIN_PUSAT: 1,
    ADMIN_PERUSAHAAN: 2,
    PIMPINAN_INSTALASI: 3,
    MANAGEMENT_ASTRA: 4,
    PIC_INSTALASI: 5,
    ASESSOR: 6,
    KEPALA_PERUSAHAAN: 7
};

export const jenisPerusahaan7Aspek = [11, 12, 13, 14];

export const FILTER_PERTANYAAN = {
    SUDAH_DIISI: 1,
    BELUM_DIISI: 2,
    SEMUA: 3
};

export const FILTER_CONFIRM = {
    SUDAH_CONFIRM: 1,
    BELUM_CONFIRM: 2,
    SEMUA: 3
};

// PADA DASARNYA SAMA FILTER-FILTER INI TAPI LEBIH MUDAH YANG DIBAWAH

export const TOGGLE_FILTER = {
    SEMUA: 0,
    ISI: 1,
    BELUM_ISI: 2
}

export const urlAstraI = 'https://agction.id/assets/img/astra-international.png';
export const urlAstraGC = 'https://agction.id/assets/img/green-company.jpg';
export const conformityfrac = 'https://agction.id/assets/img/conformityfrac.png';
export const actionqrcode = 'https://agction.id/assets/img/agction-qrcode.png';
export const cover = 'http://localhost:3000/assets/img/cover.png'
// export const conformityfrac = 'http://localhost:3000/assets/img/conformityfrac.png' //mode development
// export const actionqrcode = 'http://localhost:3000/assets/img/agction-qrcode.png' //mode development
export const MASTER_SHEET = {
    AGC_CONFORMITY: 1,
    CP_LINGKUNGAN: 2,
    CP_SAFETY: 3,
    LEGAL_COM: 4,
    FRSR: 5,
    EFISIEN_ENERGI: 6,
    ECO_LIMBAH_B3: 7,
    ECO_LIMBAH_NONB3: 8,
    ECO_CEMAR_UDARA: 9,
    KONSERVASI_AIR: 10,
    ANEKA_HAYATI: 11,
    CD: 12,
    TKTF: 13
};

export const STAGE = {
    DRAFT: 0,
    ONE_AUDIT: 1,
    ONE_NON_CONFORMITY: 2,
    TWO_AUDIT: 3
};

export const STAGE_ASSESSMENT = {
    PENGISIAN: 0,
    AUDIT: 1,
    FINAL: 2,
    EXCEPTION: 3,
}

export const SYNCHRONIZE_STATUS = {
    FIRST: 0,
    PROCESS: 1,
    DONE: 2
}

export const PILIHAN_PROGRAM = {
    PROGRAM_UTAMA: {
        ID: 1,
        LABEL: 'Program Utama'
    },
    PROGRAM_TAMBAHAN: {
        ID: 2,
        LABEL: 'Program Tambahan'
    }
}

export const DASHBOARD = {
    COLOR: ['#000', '#ff5733', '#0779e4', '#8cba51', '#ffc60b'],
    COLOR_HOVER: ['#333333', '#ff6363', '#0779e4', '#8cba51', '#ffc60b'],
    LABELS: [
        'Bintang 1',
        'Bintang 2',
        'Bintang 3',
        'Bintang 4',
        'Bintang 5',
    ],
    OPTIONS: {
        legend: {
            display: true,
            position: 'left',
            fullWidth: true,
            labels: {
                fontSize: 20,
                boxWidth: 20,
            },
        },
        scales: {
            yAxes: [{
                ticks: {
                    beginAtZero: true
                }
            }]
        }
    }
}
